import { ReactNode } from "react";

import { cn } from "@/utils/cn";

export interface LedgerRow {
  time: string;
  kind: string;
  title: string;
  status?: string;
  href?: string;
  onClick?: () => void;
}

interface Props {
  rows: LedgerRow[];
  empty?: ReactNode;
  className?: string;
}

export function LedgerTable({ rows, empty, className }: Props) {
  if (!rows.length) {
    return (
      <div className={cn("py-12 text-center text-warmgray-400", className)}>
        {empty ?? <span className="font-serif italic">No entries yet.</span>}
      </div>
    );
  }
  return (
    <div className={cn("border-t border-ruleline", className)}>
      <div className="ledger-row text-smallcaps text-warmgray-400">
        <span>Time</span>
        <span>Kind</span>
        <span>Title</span>
        <span className="text-right">Status</span>
      </div>
      {rows.map((row, idx) => {
        const cellContent = (
          <>
            <span className="font-mono text-xs text-warmgray-500">{row.time}</span>
            <span className="pill">{row.kind}</span>
            <span className="font-serif text-espresso-700">{row.title}</span>
            <span className="text-right text-xs text-warmgray-500">{row.status ?? "—"}</span>
          </>
        );
        if (row.href) {
          return (
            <a
              key={`${row.time}-${idx}`}
              className="ledger-row hover:bg-parchment-50"
              href={row.href}
            >
              {cellContent}
            </a>
          );
        }
        return (
          <button
            key={`${row.time}-${idx}`}
            type="button"
            onClick={row.onClick}
            className="ledger-row w-full text-left hover:bg-parchment-50"
          >
            {cellContent}
          </button>
        );
      })}
    </div>
  );
}
